import { Edit } from "@/components/admin/edit";
import { SimpleForm } from "@/components/admin/simple-form";
import { AccountInputs } from "./AccountInputs";

export const AccountEdit = () => (
  <Edit mutationMode="pessimistic" redirect="list">
    <SimpleForm className="max-w-3xl">
      <AccountInputs />
    </SimpleForm>
  </Edit>
);
